import React from 'react';
import { One } from './Heading.1';
import { Two } from './Heading.2';
import { Three } from './Heading.3';
import { Four } from './Heading.4';
import { Five } from './Heading.5';
import { Six } from './Heading.6';
import { groupDisplayName } from '../../utils';

const applyDisplayName = groupDisplayName('Heading');

export interface HeadingComponent extends React.FC<any> {
    Style?: any;
}

export interface HeadingGroup {
    One: HeadingComponent;
    Two: HeadingComponent;
    Three: HeadingComponent;
    Four: HeadingComponent;
    Five: HeadingComponent;
    Six: HeadingComponent;
}

export const Heading: HeadingGroup = {
    One: applyDisplayName(One) as HeadingComponent,
    Two: applyDisplayName(Two) as HeadingComponent,
    Three: applyDisplayName(Three) as HeadingComponent,
    Four: applyDisplayName(Four) as HeadingComponent,
    Five: applyDisplayName(Five) as HeadingComponent,
    Six: applyDisplayName(Six) as HeadingComponent,
};
